var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import constants, { CANADA_PROVINCES, USA_STATES } from "../config/constants";
import { getContrastRatio } from "@mui/material/styles";
const CONTRAST_DARK_TEXT = 'rgba(0, 0, 0, 0.87)';
const CONTRAST_LIGHT_TEXT = '#fff';
const CONTRAST_THRESHOLD = 3;
export const getContrastText = (background) => {
    if (!background)
        return CONTRAST_LIGHT_TEXT;
    try {
        return getContrastRatio(background, CONTRAST_DARK_TEXT) >= CONTRAST_THRESHOLD
            ? CONTRAST_DARK_TEXT
            : CONTRAST_LIGHT_TEXT;
    }
    catch (_a) {
        return CONTRAST_LIGHT_TEXT;
    }
};
export const normalizeTitleForCompare = (title) => String(title !== null && title !== void 0 ? title : '').toLowerCase().replace(/\s+/g, '');
export const resolveTitleLabel = (rawTitle, entityType) => {
    var _a, _b, _c;
    if (!rawTitle)
        return '--';
    const titleOptions = entityType
        ? ((_b = (_a = constants.ContactTitle) === null || _a === void 0 ? void 0 : _a.find((entity) => entity.EntityType === entityType)) === null || _b === void 0 ? void 0 : _b.Titles) || []
        : ((_c = constants.ContactTitle) === null || _c === void 0 ? void 0 : _c.flatMap((entity) => entity.Titles || [])) || [];
    const match = titleOptions.find((opt) => normalizeTitleForCompare(opt.value) === normalizeTitleForCompare(rawTitle) || normalizeTitleForCompare(opt.label) === normalizeTitleForCompare(rawTitle));
    return (match === null || match === void 0 ? void 0 : match.label) || rawTitle;
};
export const pwdValidation = (password, initial_pwdErrors, component) => {
    let validatePwd = Object.assign({}, initial_pwdErrors);
    let _validatePwd;
    validatePwd.isValidLength = password.trim().length >= 10;
    validatePwd.doesHvUCase = constants.regex.atleastOneUCharRegExp.test(password);
    validatePwd.doesHvLCase = constants.regex.atleastOneLCharRegExp.test(password);
    validatePwd.doesHvNum = constants.regex.atleastOneNumRegExp.test(password);
    validatePwd.doesHvSplChar = constants.regex.atleastOneSplCharRegExp.test(password);
    if (component !== undefined && component === 'passwordStrength') {
        const { isValidLength } = validatePwd, restObj = __rest(validatePwd, ["isValidLength"]);
        _validatePwd = Object.assign({}, restObj);
    }
    const isValid = Object.values(_validatePwd || validatePwd).every((criteria) => criteria === true) || !password;
    return (component !== undefined && component === 'resetPassword') ? _validatePwd || validatePwd : isValid;
};
export const getCommaSeperated = (amount) => {
    if (amount) {
        const roundedSum = parseFloat(amount === null || amount === void 0 ? void 0 : amount.toFixed(2));
        return roundedSum > 999 ? numberWithCommas(roundedSum) : roundedSum;
    }
    return '$0.00';
};
export const numberWithCommas = (x) => {
    return x ? `$${x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}.00` : 0;
};
export const isEmptyJson = (jsonData) => {
    return Object.keys(jsonData).length === 0 && jsonData.constructor === Object;
};
export const isExactDigitLength = (value, length) => new RegExp(`^\\d{${length}}$`).test(value !== null && value !== void 0 ? value : '');
export const SSN_FED_TAX_ID_LENGTH = 9;
export const isValidSSNOrFedTaxId = (value) => isExactDigitLength(value, SSN_FED_TAX_ID_LENGTH);
export const getRateForMonthlyPayments = (rate, defaultDealerMarkupRate) => {
    var _a;
    const rateNum = rate ? (typeof rate === 'string' ? parseFloat(rate) : rate) : 0;
    const dealerMarkupRate = defaultDealerMarkupRate ? Number(defaultDealerMarkupRate) : 0;
    if (isNaN(rateNum) || isNaN(dealerMarkupRate)) {
        return '0%';
    }
    const totalRate = rateNum + dealerMarkupRate;
    if (totalRate === 0) {
        return '0%';
    }
    if (totalRate % 1 !== 0 && totalRate.toFixed(2) !== totalRate.toString()) {
        return `${(_a = String(getCommaSeperatedForAmounts(totalRate, 4))) === null || _a === void 0 ? void 0 : _a.replace('$', '')}%`;
    }
    else {
        return `${totalRate}%`;
    }
};
export const isQuoteDealerMarkupEnabled = (vendorConfig) => Number(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsDealerRateAdjustmentEnabled) === 1
    && (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.DealerRateAdjustmentType) !== constants.dealerRateAdjustmentTypes.BUYDOWN;
export const getDefaultQuoteDealerMarkupRate = (vendorConfig) => {
    const defaultRate = vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.DefaultDealerMarkupRate;
    return defaultRate !== null && defaultRate !== undefined && defaultRate !== '' && !isNaN(Number(defaultRate))
        ? Number(defaultRate).toFixed(2)
        : '1.00';
};
export const getDealerRateAdjustmentFields = (rawDealerMarkupRate, rawDealerBuydownRate, dealerRateAdjustmentType, defaultDealerMarkupRate = "") => {
    if (dealerRateAdjustmentType === constants.dealerRateAdjustmentTypes.BUYDOWN) {
        return {
            DealerBuydownRate: rawDealerBuydownRate !== null && rawDealerBuydownRate !== undefined && Number(rawDealerBuydownRate) ? Number(rawDealerBuydownRate).toFixed(2) : "",
            DealerMarkupRate: "",
        };
    }
    return {
        DealerMarkupRate: rawDealerMarkupRate !== null && rawDealerMarkupRate !== undefined && Number(rawDealerMarkupRate) ? Number(rawDealerMarkupRate).toFixed(2) : String(defaultDealerMarkupRate),
        DealerBuydownRate: "",
    };
};
export const getCommaSeperatedForAmounts = (amount, decimalCount) => {
    var _a;
    if (amount !== null && amount !== undefined && amount !== '') {
        let formatAmount = amount;
        if (amount && typeof amount === 'string') {
            let value = amount === null || amount === void 0 ? void 0 : amount.replace(/[$,]/g, '');
            if (value !== null && value !== undefined && value !== '') {
                formatAmount = Number(value);
            }
        }
        const roundedSum = parseFloat((_a = Number(formatAmount)) === null || _a === void 0 ? void 0 : _a.toFixed(decimalCount ? decimalCount : 2));
        if (roundedSum) {
            const hasDecimal = String(roundedSum).includes('.');
            if (hasDecimal) {
                let sumWithCommas = numberWithCommasForAmounts(roundedSum);
                if (String(sumWithCommas).split(".")[1].length < 2) {
                    sumWithCommas = sumWithCommas + '0';
                }
                return sumWithCommas;
            }
            else {
                return numberWithCommasForAmounts(roundedSum) + '.00';
            }
        }
        if (roundedSum === 0) {
            return '$0.00';
        }
    }
    return '';
};
export const numberWithCommasForAmounts = (x) => {
    return x ? `$${x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}` : 0;
};
export const convertStringValuesToNumbers = (x) => {
    if (typeof x === 'string') {
        const value = x.replace(/[$,]/g, '');
        return value === '' ? 0 : Number(value);
    }
    return x;
};
export const toNumber = (value) => {
    if (value === null || value === undefined || value === '')
        return 0;
    const cleaned = typeof value === 'string' ? value.replace(/[$,]/g, '') : value;
    const result = Number(cleaned);
    return isNaN(result) ? 0 : result;
};
export const generateClientId = (prefix = 'id') => {
    return `${prefix}_${Date.now().toString(36)}_${Math.random()
        .toString(36)
        .slice(2, 10)}`;
};
export const getDownPaymentValue = (value) => {
    if (value) {
        if (value == '0') {
            return '$0.00';
        }
        value = value === null || value === void 0 ? void 0 : value.replace(/[^0-9.]/g, '');
        if (value === null || value === void 0 ? void 0 : value.startsWith('0')) {
            value = value.startsWith('0') ? '0' : '';
        }
        const parts = value === null || value === void 0 ? void 0 : value.split('.');
        let integerPart = parts[0];
        let decimalPart = parts[1];
        if (decimalPart !== undefined) {
            decimalPart = decimalPart.slice(0, 2);
        }
        value = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
        const formattedValue = value !== '' ? `$${value === null || value === void 0 ? void 0 : value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` : '';
        return formattedValue;
    }
    else {
        return value;
    }
};
export const getDownPaymentRoundedValue = (value) => {
    if (value) {
        if (value == '0') {
            return '$0.00';
        }
        value = value === null || value === void 0 ? void 0 : value.replace(/[^0-9.]/g, '');
        if (value === null || value === void 0 ? void 0 : value.startsWith('0')) {
            value = value.startsWith('0') ? '0' : '';
        }
        let numericValue = parseFloat(value);
        if (!Number.isInteger(numericValue)) {
            numericValue = Math.ceil(numericValue);
        }
        let stringValue = String(numericValue === null || numericValue === void 0 ? void 0 : numericValue.toFixed(2));
        const formattedValue = stringValue !== '' ? `$${stringValue === null || stringValue === void 0 ? void 0 : stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` : '';
        return formattedValue;
    }
    else {
        return value;
    }
};
export const getTotalAssetCost = (assetInfoData) => {
    if (assetInfoData === null || assetInfoData === void 0 ? void 0 : assetInfoData.length) {
        const __assetInfoData = [...assetInfoData];
        __assetInfoData.map((assetObj) => {
            if (assetObj === null || assetObj === void 0 ? void 0 : assetObj.EquipmentCost) {
                if (typeof assetObj.EquipmentCost === 'string') {
                    let equipCost = assetObj === null || assetObj === void 0 ? void 0 : assetObj.EquipmentCost;
                    let value = equipCost.replace(/[$,]/g, '');
                    if (value) {
                        assetObj.EquipmentCost = Number(value);
                    }
                }
            }
        });
        let assetEquipmentCostSum = __assetInfoData === null || __assetInfoData === void 0 ? void 0 : __assetInfoData.reduce((acc, cur) => {
            acc = acc + (cur.EquipmentCost * cur.Quantity);
            return acc;
        }, 0);
        return assetEquipmentCostSum;
    }
    return 0;
};
export const filterSpecialCharacters = (input) => {
    const filtered = input.replace(/[^\d.]/g, '');
    return Number(filtered);
};
export const maskBillingMails = (inputString, shouldMask) => {
    const emails = inputString
        .split(';')
        .map(email => email.trim())
        .filter(email => email.length > 0);
    const processedEmails = emails.map(email => {
        if (!shouldMask)
            return email;
        if (email.length <= 4)
            return '*'.repeat(email.length);
        const visibleStart = email.slice(0, 2);
        const visibleEnd = email.slice(-2);
        const maskedMiddle = '*'.repeat(email.length - 4);
        return `${visibleStart}${maskedMiddle}${visibleEnd}`;
    });
    return processedEmails.join(', ');
};
export const trimWithStars = (inputString, maskPattern = 'showFirstAndLastTwo') => {
    if (!inputString || inputString.length < 4) {
        return inputString;
    }
    switch (maskPattern) {
        case 'showLastTwo':
            const lastTwoChars = inputString.substring(inputString.length - 2);
            const starsForLast2 = '*'.repeat(inputString.length - 2);
            return starsForLast2 + lastTwoChars;
        case 'showFirstTwo':
            const firstTwoChars = inputString.substring(0, 2);
            const starsForFirst2 = '*'.repeat(inputString.length - 2);
            return firstTwoChars + starsForFirst2;
        case 'showFirstAndLastTwo':
            const firstTwo = inputString.substring(0, 2);
            const lastTwo = inputString.substring(inputString.length - 2);
            const starsForBoth2 = '*'.repeat(inputString.length - 4);
            return firstTwo + starsForBoth2 + lastTwo;
        case 'maskAll':
            return '*'.repeat(inputString.length);
        default:
            const firstTwoDefault = inputString.substring(0, 2);
            const lastTwoDefault = inputString.substring(inputString.length - 2);
            const starsForDefault = '*'.repeat(inputString.length - 4);
            return firstTwoDefault + starsForDefault + lastTwoDefault;
    }
};
export const maskEmailInText = (text) => {
    return text.replace(/\(([^)]+)\)/, (_, email) => {
        const [local, domain] = email.split("@");
        if (!domain)
            return `(${email})`;
        if (local.length > 2) {
            const maskedLocal = local[0] + "*******" + local[local.length - 1];
            return `(${maskedLocal}@${domain})`;
        }
        return `(${local}@${domain})`;
    });
};
export const getCustomerPosition = (index) => {
    switch (index) {
        case 0:
            return 'CREATE_NOR_LOC_APP.CONTACT_INFO.CUSTOMER_POSITION_1';
        case 1:
            return 'CREATE_NOR_LOC_APP.CONTACT_INFO.CUSTOMER_POSITION_2';
        case 2:
            return 'CREATE_NOR_LOC_APP.CONTACT_INFO.CUSTOMER_POSITION_3';
        case 3:
            return 'CREATE_NOR_LOC_APP.CONTACT_INFO.CUSTOMER_POSITION_4';
        default:
            return 'CREATE_NOR_LOC_APP.CONTACT_INFO.CUSTOMER_POSITION_1';
    }
};
export const getAssetListPrice = (equipmentTypeOptions, asset) => {
    var _a, _b, _c;
    if (((_a = asset === null || asset === void 0 ? void 0 : asset.__modelOptions) === null || _a === void 0 ? void 0 : _a.length) && (asset === null || asset === void 0 ? void 0 : asset.Model)) {
        const modelObj = asset.__modelOptions.find((model) => model.Name === (asset === null || asset === void 0 ? void 0 : asset.Model));
        return (modelObj === null || modelObj === void 0 ? void 0 : modelObj.ListPrice) ? Number(modelObj.ListPrice) : 0;
    }
    else if (((_b = asset === null || asset === void 0 ? void 0 : asset.__manufactureOptions) === null || _b === void 0 ? void 0 : _b.length) && (asset === null || asset === void 0 ? void 0 : asset.Manufacturer)) {
        const manufacturerObj = asset.__manufactureOptions.find((manu) => manu.Name === (asset === null || asset === void 0 ? void 0 : asset.Manufacturer));
        return (manufacturerObj === null || manufacturerObj === void 0 ? void 0 : manufacturerObj.ListPrice) ? Number(manufacturerObj.ListPrice) : 0;
    }
    else {
        return ((_c = equipmentTypeOptions === null || equipmentTypeOptions === void 0 ? void 0 : equipmentTypeOptions.find((equip) => equip.value === (asset === null || asset === void 0 ? void 0 : asset.EquipmentType))) === null || _c === void 0 ? void 0 : _c.ListPrice) || 0;
    }
};
export const containsCompleteMatch = (text, searchTerm) => {
    if (!text || !searchTerm)
        return false;
    if (text === searchTerm)
        return true;
    if (text.startsWith(searchTerm))
        return true;
    if (text.endsWith(searchTerm))
        return true;
    if (text.includes(searchTerm))
        return true;
    return false;
};
export const calculatePreTaxAmount = (amount, isTaxable, taxRate) => {
    var _a;
    if (isTaxable !== 1) {
        return String(getCommaSeperatedForAmounts(amount));
    }
    const isValidValue = (value) => {
        return value !== null && value !== undefined && value !== '';
    };
    if (!isValidValue(taxRate)) {
        return '--';
    }
    const preTaxValue = Number((_a = (amount / (1 + Number(taxRate) / 100))) === null || _a === void 0 ? void 0 : _a.toFixed(2));
    return String(getCommaSeperatedForAmounts(preTaxValue));
};
export function resolveDocTypeLabel(docObj, docList) {
    if (!docObj)
        return '';
    if (docObj.DocType !== undefined && docObj.DocType !== null) {
        const byCode = docList.find((d) => d.value === String(docObj.DocType));
        if (byCode)
            return byCode.label;
    }
    const filename = docObj.FileName || (typeof docObj.TempFile === 'string' && !docObj.TempFile.startsWith('http') ? docObj.TempFile : '') || '';
    if (filename) {
        const prefix = filename.split('_')[0];
        const norm = (s) => s.replace(/[^a-z0-9]/gi, '').toLowerCase();
        const match = docList.find((d) => norm(d.label) === norm(prefix));
        if (match)
            return match.label;
    }
    return '';
}
export function formatFileSize(value) {
    if (!value && value !== 0)
        return '';
    const bytes = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(bytes))
        return String(value);
    const b = bytes;
    if (b >= 1024 * 1024)
        return `${(b / (1024 * 1024)).toFixed(2)} MB`;
    if (b >= 1024)
        return `${(b / 1024).toFixed(0)} KB`;
    return `${b} B`;
}
export function formatUploadTimestamp(dateStr) {
    if (!dateStr)
        return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime()))
        return dateStr;
    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZone: 'America/New_York',
    }).format(d);
}
export const isFieldInConfig = (sections, apiFieldName) => Object.values(sections !== null && sections !== void 0 ? sections : {}).some((fields) => Array.isArray(fields) && fields.some((f) => f.apiFieldName === apiFieldName));
const FR_LABEL_FIXES = {
    "OPTIONS DE TARIF": "Options de tarif",
    "DURÉE DU MANDAT EN MOIS": "Durée du mandat en mois",
    "ACOMPTE": "Acompte",
    "COÛTS DOUX": "Coûts accessoires",
    "PRODUIT FINANCIER": "Produit financier",
    "COÛT TOTAL DE L'ACTIF": "Coût total de l'actif",
    "MONTANT TOTAL FINANCÉ": "Montant total financé",
    "NEUF OU USAGÉ": "Neuf ou usagé",
    "DESCRIPTION DE L'ÉQUIPEMENT": "Description de l'équipement",
    "COÛT DE L'ÉQUIPEMENT (PAR UNITÉ)": "Coût de l'équipement (par unité)",
    "MODÈLE": "Modèle",
    "ANNÉE": "Année",
    "QUANTITÉ": "Quantité",
    "PRÉNOM": "Prénom",
    "NOM DE FAMILLE": "Nom de famille",
    "E-MAIL": "E-mail",
    "NUMÉRO DE TÉLÉPHONE PORTABLE": "Numéro de téléphone portable",
    "NUMÉRO DE TÉLÉPHONE": "Numéro de téléphone",
    "SIGNATEUR DE DOCUMENT": "Signateur de document",
    "ADRESSE PRINCIPALE": "Adresse principale",
    "PAYS": "Pays",
    "VILLE": "Ville",
    "ÉTAT/PROVINCE DE CONSTITUTION": "État/Province de constitution",
    "ÉTAT/PROVINCE": "État/Province",
    "TYPE D'ENTITÉ": "Type d'entité",
    "NOM LÉGAL ENREGISTRÉ": "Nom légal enregistré",
    "NOM DBA": "Nom DBA",
    "DATE DE CONSTITUTION DE L'ENTREPRISE": "Date de constitution de l'entreprise",
    "EXEMPT D'IMPÔT": "Exempt d'impôt",
    "ZIP / CODE POSTAL": "Zip/Code postal",
    "ZIP/CODE POSTAL": "Zip/Code postal",
    "STATE/PROVINCE": "État/Province",
    "COÛT": "Coût",
};
function normalizeFrField(value) {
    var _a;
    return (_a = FR_LABEL_FIXES[value]) !== null && _a !== void 0 ? _a : value;
}
function normalizeFieldArray(fields) {
    return fields.map((field) => {
        if (!field || typeof field !== 'object')
            return field;
        const updated = Object.assign({}, field);
        if (typeof updated.fr_name === 'string')
            updated.fr_name = normalizeFrField(updated.fr_name);
        if (typeof updated.fr_placeholder === 'string')
            updated.fr_placeholder = normalizeFrField(updated.fr_placeholder);
        return updated;
    });
}
export function normalizeFrLabelsInAppJson(appJson) {
    if (!appJson || typeof appJson !== 'object')
        return appJson;
    const result = {};
    for (const sectionKey of Object.keys(appJson)) {
        const section = appJson[sectionKey];
        if (section && typeof section === 'object' && section.sections) {
            const normalizedSections = {};
            for (const subKey of Object.keys(section.sections)) {
                const fields = section.sections[subKey];
                normalizedSections[subKey] = Array.isArray(fields) ? normalizeFieldArray(fields) : fields;
            }
            result[sectionKey] = Object.assign(Object.assign({}, section), { sections: normalizedSections });
        }
        else {
            result[sectionKey] = section;
        }
    }
    return result;
}
export function mergeAppJsonWithFrNames(referenceJson, apiJson) {
    var _a, _b, _c, _d;
    if (!apiJson || typeof apiJson !== 'object')
        return referenceJson;
    if (!referenceJson || typeof referenceJson !== 'object')
        return normalizeFrLabelsInAppJson(apiJson);
    const refLookup = {};
    for (const sectionKey of Object.keys(referenceJson)) {
        const section = referenceJson[sectionKey];
        if (section === null || section === void 0 ? void 0 : section.sections) {
            refLookup[sectionKey] = {};
            for (const subKey of Object.keys(section.sections)) {
                refLookup[sectionKey][subKey] = {};
                const fields = (_a = section.sections[subKey]) !== null && _a !== void 0 ? _a : [];
                for (const field of fields) {
                    if (field === null || field === void 0 ? void 0 : field.apiFieldName) {
                        refLookup[sectionKey][subKey][field.apiFieldName] = field;
                    }
                }
            }
        }
    }
    const merged = Object.assign({}, referenceJson);
    for (const sectionKey of Object.keys(apiJson)) {
        const apiSection = apiJson[sectionKey];
        if (!(apiSection === null || apiSection === void 0 ? void 0 : apiSection.sections)) {
            merged[sectionKey] = apiSection;
            continue;
        }
        const mergedSections = {};
        for (const subKey of Object.keys(apiSection.sections)) {
            const apiFields = (_b = apiSection.sections[subKey]) !== null && _b !== void 0 ? _b : [];
            const refFields = (_d = (_c = refLookup[sectionKey]) === null || _c === void 0 ? void 0 : _c[subKey]) !== null && _d !== void 0 ? _d : {};
            mergedSections[subKey] = apiFields.map((field) => {
                var _a;
                if (!field || typeof field !== 'object')
                    return field;
                const refField = (_a = refFields[field.apiFieldName]) !== null && _a !== void 0 ? _a : {};
                const merged = Object.assign({}, field);
                if (!merged.fr_name && refField.fr_name)
                    merged.fr_name = refField.fr_name;
                if (!merged.fr_placeholder && refField.fr_placeholder)
                    merged.fr_placeholder = refField.fr_placeholder;
                if (typeof merged.fr_name === 'string')
                    merged.fr_name = normalizeFrField(merged.fr_name);
                if (typeof merged.fr_placeholder === 'string')
                    merged.fr_placeholder = normalizeFrField(merged.fr_placeholder);
                return merged;
            });
        }
        merged[sectionKey] = Object.assign(Object.assign({}, apiSection), { sections: mergedSections });
    }
    return merged;
}
export const getCountryCodeFromState = (stateCode) => {
    if (!stateCode || !String(stateCode).trim())
        return null;
    return USA_STATES.some((state) => state.code === stateCode) ? 'USA' : 'CAN';
};
export const getStateOptionsForCountry = (country) => {
    const code = String(country !== null && country !== void 0 ? country : '').trim().toUpperCase();
    if (code === 'USA' || code === 'US')
        return USA_STATES;
    if (code === 'CAN' || code === 'CA' || code === 'CANADA')
        return CANADA_PROVINCES;
    return [];
};
export const getModelListPrice = (modelObj, year) => { var _a, _b; return (_b = (_a = ((modelObj === null || modelObj === void 0 ? void 0 : modelObj.Year) || []).find((yearOpt) => String(yearOpt === null || yearOpt === void 0 ? void 0 : yearOpt.Name) === String(year))) === null || _a === void 0 ? void 0 : _a.ListPrice) !== null && _b !== void 0 ? _b : modelObj === null || modelObj === void 0 ? void 0 : modelObj.ListPrice; };
